export default __webpack_public_path__ + "static/media/meetRoom.27865545.svg";